module.exports = __webpack_public_path__ + "img/pricing-1.0bd8a344.svg";